export default "__VITE_ASSET__AX0jBTLY__"